import { getLastCommentScope } from 'library-@/components/comments/services/last-comment-scope';

const DEFAULT_SCOPE_KEY_NORMAL = 'SPACE';
const DEFAULT_SCOPE_KEY_PERSONAL = 'PRIVATE';

/**
 * 解析当前空间对应的注释可见范围 key
 * - 优先使用浏览器缓存中的上次选择 (WS:LastCommentScope)
 * - 个人空间下若缓存命中 ORG, 自动降级为 PRIVATE
 * - 无缓存时, 个人空间默认 PRIVATE, 其他默认 SPACE
 */
export function resolveScopeKey(isPersonal: boolean): string {
    const last = getLastCommentScope();
    if (last && typeof last.key === 'string') {
        if (isPersonal && last.key === 'ORG') {
            return DEFAULT_SCOPE_KEY_PERSONAL;
        }
        return last.key;
    }
    return isPersonal ? DEFAULT_SCOPE_KEY_PERSONAL : DEFAULT_SCOPE_KEY_NORMAL;
}
